import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-center',
  templateUrl: './grid-center.component.html',
  styleUrls: ['./grid-center.component.scss'],
})
export class GridCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
